// extracted by mini-css-extract-plugin
export var errorsContainer = "_ur-1";
export var link = "_ur-0";